import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { ActivityIndicator, ScrollView, TouchableOpacity, View } from 'react-native';
import { Icon } from 'react-native-elements';
import { connect, useDispatch } from 'react-redux';
import Colors from '../../constants/Colorsv2';
import { Text } from '../../globalComponents/NativeOverrides';
import { MetricsComponent } from '../../objectTypes';
import { FilterType } from '../../store/actions/analyticActions';
import { AnalyticLineChart, AnalyticPieChart } from './AnalyticComponents/AnalyticCharts';
import MetricCard from './AnalyticComponents/MetricCard';
import 'react-calendar/dist/Calendar.css';
import FilterCard from './AnalyticComponents/FilterCard';
import { analytics_getMetricsByFilter } from '../../store/actionsv1/analytics';


const OverallMetricScreen = ({ navigation, metrics_data, market_type, filter }:{ metrics_data:MetricsComponent[], filter:FilterType }) => {
    const [ loading, setLoading ] = useState(false)
    const [ filterVisible, setFilterVisible ] = useState(true)
    const [ screenWidth, setScreenWidth ] = useState(400)
    const [ activeDataPoint, setActiveDataPoint ] = useState(`earnings`)
    const [ filterHeight, setFilterHeight ] = useState(70);

    const dispatch = useDispatch();

    useEffect(() => {
        getMetricsFromServer(filter)
    },[])

    const getMetricsFromServer = async(filter:FilterType) => {
        setLoading(true)
        await dispatch(analytics_getMetricsByFilter({ ...filter, data_level: 'overall', market_type }))
        setTimeout(() => {
            setLoading(false)
        }, 1000);
    }

    const handleScrollEvent = (ev:any) => {
        const contentOffset = ev.nativeEvent.contentOffset.y
        if(contentOffset > 5){ setFilterVisible(false); setFilterHeight(0); return; }
        return setFilterVisible(true) 
    }

    const chartMinWidth = 100
    const renderPieCharts = (data: {item:MetricsComponent, index:number}) => {
        return (
            <View style={{ justifyContent:'center', alignItems:'center', backgroundColor:Colors.shades.shade200, borderRadius:8, padding:5, margin:5, minWidth:chartMinWidth }}>
                <Text size={14} color={Colors.brand.midnight} weight='semibold'>{data.item.metric_name}</Text>
                <AnalyticPieChart  data={data.item.chart_data} width={(screenWidth-40)/2}/>
            </View>
        )
    }
    
    //Overall Metrics
    const overall_roi = metrics_data.find(d => d.metric_id === 'metric:overall:roi')
    const overall_invested = metrics_data.find(d => d.metric_id === 'metric:overall:invested')
    const overall_earnings = metrics_data.find(d => d.metric_id === 'metric:overall:earnings')
    const overall_line_data = metrics_data.find(d => d.chart_type === 'line_chart' && d.metric_id === `chart:overall:${activeDataPoint}`)?.chart_data??[]
    
    //Markets Data
    const markets_roi = metrics_data.find(d => d.metric_id === 'metric:markets:roi')
    const markets_invested = metrics_data.find(d => d.metric_id === 'metric:markets:invested')
    const markets_earnings = metrics_data.find(d => d.metric_id === 'metric:markets:earnings')
    const markets_line_data = metrics_data.find(d => d.chart_type === 'line_chart' && d.metric_id === `chart:markets:${activeDataPoint}`)?.chart_data??[]
    
    //Competitions Data
    const competitions_roi = metrics_data.find(d => d.metric_id === 'metric:competitions:roi')
    const competitions_invested = metrics_data.find(d => d.metric_id === 'metric:competitions:invested')
    const competitions_earnings = metrics_data.find(d => d.metric_id === 'metric:competitions:earnings')
    const competitions_line_data = metrics_data.find(d => d.chart_type === 'line_chart' && d.metric_id === `chart:competitions:${activeDataPoint}`)?.chart_data??[]
    
    //Competitions Data
    const squares_roi = metrics_data.find(d => d.metric_id === 'metric:squares:roi')
    const squares_invested = metrics_data.find(d => d.metric_id === 'metric:squares:invested')
    const squares_earnings = metrics_data.find(d => d.metric_id === 'metric:squares:earnings')
    const squares_line_data = metrics_data.find(d => d.chart_type === 'line_chart' && d.metric_id === `chart:squares:${activeDataPoint}`)?.chart_data??[]
    const pie_data = metrics_data.filter(d => d.chart_type === 'pie_chart')
    


    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView scrollEventThrottle={10} onScroll={(ev) => handleScrollEvent(ev)} style={{flex:1, margin:5, marginTop:filterHeight+10}} showsVerticalScrollIndicator={false}>
                {loading ? 
                <View style={{justifyContent:'center', alignItems:'center', marginTop:20}}>
                    <ActivityIndicator size='large' color={Colors.brand.midnight} />
                </View>
                :
                <View onLayout={(ev) => {
                    setScreenWidth(ev.nativeEvent.layout.width)
                }}>

                    <View style={{ backgroundColor:Colors.shades.shade200, borderRadius:8, padding:16, margin:5 }}>
                        <Text size={16} color={Colors.brand.midnight} weight='semibold' textAlign='left'>Overall Performance</Text>
                        <View style={{ backgroundColor:Colors.shades.shade100, marginTop:20 }}>
                            {overall_roi ?
                            <MetricCard market_type={market_type} metric={overall_roi} show_filter={false} />
                            :<></>}
                        </View>
                        <View style={{flexDirection:'row', backgroundColor:'#F2F5F7', borderRadius:20, padding:8, marginTop:12}}>
                            <TouchableOpacity style={{flex:1, borderRadius:20, backgroundColor:activeDataPoint==='invested'?Colors.shades.white:'transparent'}} onPress={() => setActiveDataPoint('invested')}>
                                {overall_invested ?
                                <MetricCard market_type={market_type} show_filter={false} metric={overall_invested}/>
                                :<></>}
                            </TouchableOpacity>
                            <TouchableOpacity style={{flex:1, borderRadius:20, backgroundColor:activeDataPoint==='earnings'?Colors.shades.white:'transparent'}} onPress={() => setActiveDataPoint('earnings')}>
                                {overall_earnings ?
                                <MetricCard market_type={market_type} metric={overall_earnings} show_filter={false}/>
                                :<></>}
                            </TouchableOpacity>
                        </View>
                        <View style={{marginTop:20}}>
                            <AnalyticLineChart data={overall_line_data} width={screenWidth-30}/>
                        </View>
                    </View>
                    {false ?
                    <View style={{flexDirection:'row', flexWrap:'wrap'}}>
                        {pie_data.map((d,i) => renderPieCharts({item:d, index:i}))}
                    </View>
                    :<></> }


                    <View style={{ backgroundColor:Colors.shades.shade200, borderRadius:8, padding:16, margin:5, marginTop:25 }}>
                        <Text size={16} color={Colors.brand.midnight} weight='semibold' textAlign='left'>Markets Performance</Text>
                        <View style={{ backgroundColor:Colors.shades.shade100, marginTop:20 }}>
                            {markets_roi ?
                            <MetricCard market_type={market_type} metric={markets_roi} show_filter={false} />
                                :<></>}
                        </View>
                        <View style={{flexDirection:'row', backgroundColor:'#F2F5F7', borderRadius:20, padding:8, marginTop:12}}>
                            <TouchableOpacity style={{flex:1, borderRadius:20, backgroundColor:activeDataPoint==='invested'?Colors.shades.white:'transparent'}} onPress={() => setActiveDataPoint('invested')}>
                                {markets_invested ?
                                <MetricCard market_type={market_type} metric={markets_invested} show_filter={false} />
                                :<></>}
                            </TouchableOpacity>
                            <TouchableOpacity style={{flex:1, borderRadius:20, backgroundColor:activeDataPoint==='earnings'?Colors.shades.white:'transparent'}} onPress={() => setActiveDataPoint('earnings')}>
                                {markets_earnings ?
                                <MetricCard market_type={market_type} metric={markets_earnings} show_filter={false} />
                                :<></>}
                            </TouchableOpacity>
                        </View>
                        <View style={{marginTop:20}}>
                            <AnalyticLineChart data={markets_line_data} width={screenWidth-30}/>
                            <TouchableOpacity style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-end'}} onPress={() => navigation.navigate('ActivityMetrics')}>
                                <Text size={14} weight='semibold' color={Colors.brand.electric} textAlign='right' style={{marginRight:3}}>See Details</Text>
                                <Icon name='chevron-right' color={Colors.brand.electric} type='feather' size={14}/>
                            </TouchableOpacity>
                        </View>
                    </View>

                    {false ?
                    <View style={{ backgroundColor:Colors.shades.shade200, borderRadius:8, padding:16, margin:5, marginTop:25 }}>
                        <Text size={16} color={Colors.brand.midnight} weight='semibold' textAlign='center'>Competitions Performance</Text>
                        <View style={{ backgroundColor:Colors.shades.shade100, marginTop:20 }}>
                            {competitions_roi ?
                            <MetricCard market_type={market_type} metric={competitions_roi} show_filter={false} />
                            :<></>}
                        </View>
                        <View style={{flexDirection:'row', backgroundColor:'#F2F5F7', borderRadius:20, padding:8, marginTop:12}}>
                            <TouchableOpacity style={{flex:1, borderRadius:20, backgroundColor:activeDataPoint==='invested'?Colors.shades.white:'transparent'}} onPress={() => setActiveDataPoint('invested')}>
                                {competitions_invested ?
                                <MetricCard market_type={market_type} metric={competitions_invested} show_filter={false} />
                                :<></>}
                            </TouchableOpacity>
                            <TouchableOpacity style={{flex:1, borderRadius:20, backgroundColor:activeDataPoint==='earnings'?Colors.shades.white:'transparent'}} onPress={() => setActiveDataPoint('earnings')}>
                                {competitions_earnings ?
                                <MetricCard market_type={market_type} metric={competitions_earnings} show_filter={false} />
                                :<></>}
                            </TouchableOpacity>
                        </View>
                        <View style={{marginTop:20}}>
                            <AnalyticLineChart data={competitions_line_data} width={screenWidth-30}/>
                            <TouchableOpacity style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-end'}} onPress={() => navigation.navigate('CompPerformance')}>
                                <Text size={12} weight='semibold' color={Colors.brand.electric} textAlign='right' style={{marginRight:3}}>See Details</Text>
                                <Icon name='chevron-right' color={Colors.brand.electric} type='feather' size={14}/>
                            </TouchableOpacity>
                        </View>
                    </View>
                    :<></>}

                    <View style={{ backgroundColor:Colors.shades.shade200, borderRadius:8, padding:16, margin:5, marginTop:25 }}>
                        <Text size={16} color={Colors.brand.midnight} weight='semibold' textAlign='left'>Squares Performance</Text>
                        <View style={{ backgroundColor:Colors.shades.shade100, marginTop:20 }}>
                            {squares_roi ?
                            <MetricCard market_type={market_type} metric={squares_roi} show_filter={false} />
                            :<></>}
                        </View>
                        <View style={{flexDirection:'row', backgroundColor:'#F2F5F7', borderRadius:20, padding:8, marginTop:24}}>
                            <TouchableOpacity style={{flex:1, borderRadius:20, backgroundColor:activeDataPoint==='invested'?Colors.shades.white:'transparent'}} onPress={() => setActiveDataPoint('invested')}>
                            {squares_invested ?
                                <MetricCard market_type={market_type} metric={squares_invested} show_filter={false} />
                                :<></>}
                            </TouchableOpacity>
                            <TouchableOpacity style={{flex:1, borderRadius:20, backgroundColor:activeDataPoint==='earnings'?Colors.shades.white:'transparent'}} onPress={() => setActiveDataPoint('earnings')}>
                                {squares_earnings ? 
                                <MetricCard market_type={market_type} metric={squares_earnings} show_filter={false} />
                                :<></>}
                            </TouchableOpacity>
                        </View>
                        <View style={{marginTop:20}}>
                            <AnalyticLineChart data={squares_line_data} width={screenWidth-30}/>
                        </View>
                    </View>
                </View>
                }
            </ScrollView>
            {filterVisible ?
            <FilterCard loading={loading} onHeightChange={(height:number) => setFilterHeight(height)} filter={filter} onChange={(filter:FilterType) => getMetricsFromServer(filter)}/>
            :<></>}
        </View>
    )
}


const mapStateToProps = (state:any) => {
    return {
        metrics_data: state.analytics.metrics.overall,
        market_type: state.auth.market_type,
        filter:  state.analytics.filter
    }
}

const mapDispatchToProps = (dispatch:any) => {
    return {
        //getMetricsByFilter: (filter:FilterType) => dispatch(getMetricsByFilter(filter)),
        //updateMetricFilter:(filter:FilterType) => dispatch(updateMetricFilter(filter))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OverallMetricScreen)